module.exports = __webpack_public_path__ + "static/media/img2-2.9757c0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/biosense/diff/img2-2.png
// module id = 1980
// module chunks = 3